import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetActivityRequest, UseGetActivityData, UseGetActivityTypeListRequest, UseGetActivityTypeListData, UseGetCustomerUsageHistoryRequest, UseGetCustomerUsageHistoryData, UseGetGroupRequest, UseGetGroupData, UseGetGroupActivityPageRequest, UseGetGroupActivityPageData, UseGetGroupMemberRequest, UseGetGroupMemberData, UseGetGroupMemberPageRequest, UseGetGroupMemberPageData, UseGetGroupMemberPetDetailRequest, UseGetGroupMemberPetDetailData, UseGetGroupMemberPetPageRequest, UseGetGroupMemberPetPageData, UseGetGroupPageRequest, UseGetGroupPageData, UseGetGroupPetDetailRequest, UseGetGroupPetDetailData, UseGetGroupPetPageRequest, UseGetGroupPetPageData, UseGetGroupScheduleListRequest, UseGetGroupScheduleListData, UseGetImage1Request, UseGetImage1Data, UseGetImageList1Request, UseGetImageList1Data, UseGetMyGroupListRequest, UseGetMyGroupListData, UseGetPatternSchedulesRequest, UseGetPatternSchedulesData, UseGetPetActiveScheduleRequest, UseGetPetActiveScheduleData, UseGetPetActivityListRequest, UseGetPetActivityListData, UseGetRecurringPatternRequest, UseGetRecurringPatternData, UseGetRecurringPatternListRequest, UseGetRecurringPatternListData, UseGetScheduleActivityListRequest, UseGetScheduleActivityListData, UseSearchSimilarMembersRequest, UseSearchSimilarMembersData } from "@api/@types/group";

export const useGetActivity = createApiQuery<UseGetActivityData, UseGetActivityRequest>({
  queryKey: (req) => ["getActivity", req?.groupId, req?.activityId],
  queryFn: (req) => apiClientManager.apis.group.getActivity(req as UseGetActivityRequest),
  extractData: (res) => res.data.data as UseGetActivityData,
  isEnabled: (req) => Boolean(req?.groupId && req?.activityId),
});

export const useGetActivityTypeList = createApiQuery<UseGetActivityTypeListData, UseGetActivityTypeListRequest>({
  queryKey: (req) => ["getActivityTypeList", req?.groupId, req?.includeInactive],
  queryFn: (req) => apiClientManager.apis.group.getActivityTypeList(req as UseGetActivityTypeListRequest),
  extractData: (res) => res.data.data as UseGetActivityTypeListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetCustomerUsageHistory = createApiQuery<UseGetCustomerUsageHistoryData, UseGetCustomerUsageHistoryRequest>({
  queryKey: (req) => ["getCustomerUsageHistory", req?.groupId, req?.userId, req?.pageable],
  queryFn: (req) => apiClientManager.apis.group.getCustomerUsageHistory(req as UseGetCustomerUsageHistoryRequest),
  extractData: (res) => res.data.data as UseGetCustomerUsageHistoryData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.pageable),
});

export const useGetGroup = createApiQuery<UseGetGroupData, UseGetGroupRequest>({
  queryKey: (req) => ["getGroup", req?.groupId],
  queryFn: (req) => apiClientManager.apis.group.getGroup(req as UseGetGroupRequest),
  extractData: (res) => res.data.data as UseGetGroupData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetGroupActivityPage = createApiQuery<UseGetGroupActivityPageData, UseGetGroupActivityPageRequest>({
  queryKey: (req) => ["getGroupActivityPage", req?.groupId, req?.pageable, req?.petId, req?.statuses, req?.startDateTime, req?.endDateTime, req?.managerId, req?.activityTypeId],
  queryFn: (req) => apiClientManager.apis.group.getGroupActivityPage(req as UseGetGroupActivityPageRequest),
  extractData: (res) => res.data.data as UseGetGroupActivityPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.pageable),
});

export const useGetGroupMember = createApiQuery<UseGetGroupMemberData, UseGetGroupMemberRequest>({
  queryKey: (req) => ["getGroupMember", req?.groupId, req?.userId],
  queryFn: (req) => apiClientManager.apis.group.getGroupMember(req as UseGetGroupMemberRequest),
  extractData: (res) => res.data.data as UseGetGroupMemberData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId),
});

export const useGetGroupMemberPage = createApiQuery<UseGetGroupMemberPageData, UseGetGroupMemberPageRequest>({
  queryKey: (req) => ["getGroupMemberPage", req?.groupId, req?.pageable, req?.role, req?.name, req?.phone],
  queryFn: (req) => apiClientManager.apis.group.getGroupMemberPage(req as UseGetGroupMemberPageRequest),
  extractData: (res) => res.data.data as UseGetGroupMemberPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.pageable),
});

export const useGetGroupMemberPetDetail = createApiQuery<UseGetGroupMemberPetDetailData, UseGetGroupMemberPetDetailRequest>({
  queryKey: (req) => ["getGroupMemberPetDetail", req?.groupId, req?.userId, req?.petId],
  queryFn: (req) => apiClientManager.apis.group.getGroupMemberPetDetail(req as UseGetGroupMemberPetDetailRequest),
  extractData: (res) => res.data.data as UseGetGroupMemberPetDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.petId),
});

export const useGetGroupMemberPetPage = createApiQuery<UseGetGroupMemberPetPageData, UseGetGroupMemberPetPageRequest>({
  queryKey: (req) => ["getGroupMemberPetPage", req?.groupId, req?.userId, req?.pageable],
  queryFn: (req) => apiClientManager.apis.group.getGroupMemberPetPage(req as UseGetGroupMemberPetPageRequest),
  extractData: (res) => res.data.data as UseGetGroupMemberPetPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.pageable),
});

export const useGetGroupPage = createApiQuery<UseGetGroupPageData, UseGetGroupPageRequest>({
  queryKey: (req) => ["getGroupPage", req?.pageable, req?.name, req?.location],
  queryFn: (req) => apiClientManager.apis.group.getGroupPage(req as UseGetGroupPageRequest),
  extractData: (res) => res.data.data as UseGetGroupPageData,
  isEnabled: (req) => Boolean(req?.pageable),
});

export const useGetGroupPetDetail = createApiQuery<UseGetGroupPetDetailData, UseGetGroupPetDetailRequest>({
  queryKey: (req) => ["getGroupPetDetail", req?.groupId, req?.petId],
  queryFn: (req) => apiClientManager.apis.group.getGroupPetDetail(req as UseGetGroupPetDetailRequest),
  extractData: (res) => res.data.data as UseGetGroupPetDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.petId),
});

export const useGetGroupPetPage = createApiQuery<UseGetGroupPetPageData, UseGetGroupPetPageRequest>({
  queryKey: (req) => ["getGroupPetPage", req?.groupId, req?.pageable, req?.ownerPhone, req?.petName, req?.isUsing],
  queryFn: (req) => apiClientManager.apis.group.getGroupPetPage(req as UseGetGroupPetPageRequest),
  extractData: (res) => res.data.data as UseGetGroupPetPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.pageable),
});

export const useGetGroupScheduleList = createApiQuery<UseGetGroupScheduleListData, UseGetGroupScheduleListRequest>({
  queryKey: (req) => ["getGroupScheduleList", req?.groupId, req?.startAt, req?.endAt, req?.ownerName, req?.ownerPhone, req?.petName, req?.petId, req?.managerName, req?.statuses],
  queryFn: (req) => apiClientManager.apis.group.getGroupScheduleList(req as UseGetGroupScheduleListRequest),
  extractData: (res) => res.data.data as UseGetGroupScheduleListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetImage1 = createApiQuery<UseGetImage1Data, UseGetImage1Request>({
  queryKey: (req) => ["getImage1", req?.groupId, req?.petId, req?.imageId],
  queryFn: (req) => apiClientManager.apis.group.getImage1(req as UseGetImage1Request),
  extractData: (res) => res.data.data as UseGetImage1Data,
  isEnabled: (req) => Boolean(req?.groupId && req?.petId && req?.imageId),
});

export const useGetImageList1 = createApiQuery<UseGetImageList1Data, UseGetImageList1Request>({
  queryKey: (req) => ["getImageList1", req?.groupId, req?.petId],
  queryFn: (req) => apiClientManager.apis.group.getImageList1(req as UseGetImageList1Request),
  extractData: (res) => res.data.data as UseGetImageList1Data,
  isEnabled: (req) => Boolean(req?.groupId && req?.petId),
});

export const useGetMyGroupList = createApiQuery<UseGetMyGroupListData, UseGetMyGroupListRequest>({
  queryKey: () => ["getMyGroupList", "all"],
  queryFn: (req) => apiClientManager.apis.group.getMyGroupList(req as UseGetMyGroupListRequest),
  extractData: (res) => res.data.data as UseGetMyGroupListData,
  isEnabled: () => true,
});

export const useGetPatternSchedules = createApiQuery<UseGetPatternSchedulesData, UseGetPatternSchedulesRequest>({
  queryKey: (req) => ["getPatternSchedules", req?.groupId, req?.patternId],
  queryFn: (req) => apiClientManager.apis.group.getPatternSchedules(req as UseGetPatternSchedulesRequest),
  extractData: (res) => res.data.data as UseGetPatternSchedulesData,
  isEnabled: (req) => Boolean(req?.groupId && req?.patternId),
});

export const useGetPetActiveSchedule = createApiQuery<UseGetPetActiveScheduleData, UseGetPetActiveScheduleRequest>({
  queryKey: (req) => ["getPetActiveSchedule", req?.petId, req?.groupId],
  queryFn: (req) => apiClientManager.apis.group.getPetActiveSchedule(req as UseGetPetActiveScheduleRequest),
  extractData: (res) => res.data.data as UseGetPetActiveScheduleData,
  isEnabled: (req) => Boolean(req?.petId && req?.groupId),
});

export const useGetPetActivityList = createApiQuery<UseGetPetActivityListData, UseGetPetActivityListRequest>({
  queryKey: (req) => ["getPetActivityList", req?.groupId, req?.petId, req?.startTime, req?.endTime],
  queryFn: (req) => apiClientManager.apis.group.getPetActivityList(req as UseGetPetActivityListRequest),
  extractData: (res) => res.data.data as UseGetPetActivityListData,
  isEnabled: (req) => Boolean(req?.groupId && req?.petId),
});

export const useGetRecurringPattern = createApiQuery<UseGetRecurringPatternData, UseGetRecurringPatternRequest>({
  queryKey: (req) => ["getRecurringPattern", req?.groupId, req?.patternId],
  queryFn: (req) => apiClientManager.apis.group.getRecurringPattern(req as UseGetRecurringPatternRequest),
  extractData: (res) => res.data.data as UseGetRecurringPatternData,
  isEnabled: (req) => Boolean(req?.groupId && req?.patternId),
});

export const useGetRecurringPatternList = createApiQuery<UseGetRecurringPatternListData, UseGetRecurringPatternListRequest>({
  queryKey: (req) => ["getRecurringPatternList", req?.groupId],
  queryFn: (req) => apiClientManager.apis.group.getRecurringPatternList(req as UseGetRecurringPatternListRequest),
  extractData: (res) => res.data.data as UseGetRecurringPatternListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetScheduleActivityList = createApiQuery<UseGetScheduleActivityListData, UseGetScheduleActivityListRequest>({
  queryKey: (req) => ["getScheduleActivityList", req?.groupId, req?.scheduleId],
  queryFn: (req) => apiClientManager.apis.group.getScheduleActivityList(req as UseGetScheduleActivityListRequest),
  extractData: (res) => res.data.data as UseGetScheduleActivityListData,
  isEnabled: (req) => Boolean(req?.groupId && req?.scheduleId),
});

export const useSearchSimilarMembers = createApiQuery<UseSearchSimilarMembersData, UseSearchSimilarMembersRequest>({
  queryKey: (req) => ["searchSimilarMembers", req?.groupId, req?.name, req?.phone, req?.limit],
  queryFn: (req) => apiClientManager.apis.group.searchSimilarMembers(req as UseSearchSimilarMembersRequest),
  extractData: (res) => res.data.data as UseSearchSimilarMembersData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export type { UseGetActivityRequest, UseGetActivityData, UseGetActivityTypeListRequest, UseGetActivityTypeListData, UseGetCustomerUsageHistoryRequest, UseGetCustomerUsageHistoryData, UseGetGroupRequest, UseGetGroupData, UseGetGroupActivityPageRequest, UseGetGroupActivityPageData, UseGetGroupMemberRequest, UseGetGroupMemberData, UseGetGroupMemberPageRequest, UseGetGroupMemberPageData, UseGetGroupMemberPetDetailRequest, UseGetGroupMemberPetDetailData, UseGetGroupMemberPetPageRequest, UseGetGroupMemberPetPageData, UseGetGroupPageRequest, UseGetGroupPageData, UseGetGroupPetDetailRequest, UseGetGroupPetDetailData, UseGetGroupPetPageRequest, UseGetGroupPetPageData, UseGetGroupScheduleListRequest, UseGetGroupScheduleListData, UseGetImage1Request, UseGetImage1Data, UseGetImageList1Request, UseGetImageList1Data, UseGetMyGroupListRequest, UseGetMyGroupListData, UseGetPatternSchedulesRequest, UseGetPatternSchedulesData, UseGetPetActiveScheduleRequest, UseGetPetActiveScheduleData, UseGetPetActivityListRequest, UseGetPetActivityListData, UseGetRecurringPatternRequest, UseGetRecurringPatternData, UseGetRecurringPatternListRequest, UseGetRecurringPatternListData, UseGetScheduleActivityListRequest, UseGetScheduleActivityListData, UseSearchSimilarMembersRequest, UseSearchSimilarMembersData } from "@api/@types/group";
